export const INIT = 'init';
export const LOADING = 'loading';
export const SUCCESS = 'success';
export const ERROR = 'error';
export const SAVED = 'saved';
